/* Sage Sydney — cart drawer enhancements (Soof & Bloom 1:1, on the Wonder/Dawn theme).
   Shipping-protection auto-add + toggle, custom qty/remove (live-key lookup, immune to
   stale rendered keys once a cart discount applies), and an "Others also bought" recs slider.
   Re-renders the native Wonder drawer via the Dawn sections flow. */
(function () {
  if (window.__ssCart) return;
  window.__ssCart = true;

  var PROTECT = 53153219117384;        // Shipping Protection variant
  var OPTOUT = 'ss_protect_off';
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var lock = false;
  var recsKey = '';
  var recsHtml = '';

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function getJSON(url) { return fetch(url, { headers: { 'Content-Type': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }); }

  /* Re-render from a cart-change/add response. scope 'footer' updates only the footer
     (protection toggle + checkout total) — no item/image reload, so protection add/remove
     is seamless; 'full' (default) swaps the whole drawer inner (needed for item/qty changes).
     We never publish(cartUpdate): Wonder's native CartDrawerItems would otherwise overwrite
     our custom markup with the cart-page section. */
  function renderSections(sections, scope) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      if (scope === 'footer') {
        var sf = parsed.querySelector('.wt-cart__drawer__footer');
        var df = document.querySelector('#CartDrawer .wt-cart__drawer__footer');
        if (sf && df) df.innerHTML = sf.innerHTML;
      } else {
        var src = parsed.querySelector('.drawer__inner');
        var dest = document.querySelector('#CartDrawer .drawer__inner');
        if (src && dest) dest.innerHTML = src.innerHTML;
      }
    }
    if (sections['cart-icon-bubble']) {
      var pb = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var sb = pb.querySelector('.shopify-section') || pb.body;
      var db = document.getElementById('cart-icon-bubble');
      if (sb && db) db.innerHTML = sb.innerHTML;
    }
  }

  function mutate(endpoint, body, scope) {
    body.sections = SECTIONS;
    body.sections_url = window.location.pathname;
    return fetch(root() + 'cart/' + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        renderSections(data.sections, scope);
        return getJSON(root() + 'cart.js');
      })
      .then(function (cart) {
        var cd = document.querySelector('cart-drawer');
        if (cd) cd.classList.toggle('wt-cart--empty', (cart.item_count || 0) === 0);
        loadRecs(cart); ensureProtect(cart); return cart;
      });
  }

  function hasProtect(cart) { return (cart.items || []).some(function (i) { return i.variant_id === PROTECT; }); }
  function eligibleCount(cart) { return (cart.items || []).reduce(function (n, i) { return n + (i.variant_id === PROTECT ? 0 : i.quantity); }, 0); }
  function optedOut() { try { return localStorage.getItem(OPTOUT) === '1'; } catch (e) { return false; } }

  function protectLine(cart) { return (cart.items || []).filter(function (i) { return i.variant_id === PROTECT; })[0]; }

  function removeProtect(scope) {
    return getJSON(root() + 'cart.js').then(function (cart) {
      var line = protectLine(cart);
      if (!line) return cart;
      return mutate('change.js', { id: line.key, quantity: 0 }, scope);
    });
  }

  function ensureProtect(cart) {
    if (lock) return;
    if (eligibleCount(cart) < 1) {
      /* no real items left -> drop the protection-only leftover and show the empty cart (full render) */
      if (hasProtect(cart)) { lock = true; removeProtect('full').catch(function () {}).finally(function () { lock = false; }); }
      return;
    }
    if (optedOut()) { if (hasProtect(cart)) { lock = true; removeProtect('footer').catch(function () {}).finally(function () { lock = false; }); } return; }
    if (hasProtect(cart)) return;
    lock = true;
    addProtectionMutate().catch(function () {}).finally(function () { lock = false; });
  }

  /* protection toggle */
  document.addEventListener('change', function (e) {
    var t = e.target.closest ? e.target.closest('[data-ss-protect-toggle]') : null;
    if (!t || lock) return;
    lock = true;
    var p;
    if (t.checked) { try { localStorage.removeItem(OPTOUT); } catch (x) {} p = addProtectionMutate(); }
    else { try { localStorage.setItem(OPTOUT, '1'); } catch (x) {} p = removeProtect('footer'); }
    p.catch(function () {}).finally(function () { lock = false; });
  });

  /* recommendation +Add */
  document.addEventListener('click', function (e) {
    var add = e.target.closest ? e.target.closest('[data-sb-rec-add]') : null;
    if (!add) return;
    e.preventDefault();
    var id = add.getAttribute('data-sb-rec-add');
    var card = add.closest('.sb-rec');
    var sel = card ? card.querySelector('[data-sb-rec-variant]') : null;
    if (sel && sel.value) id = sel.value;
    if (!id) return;
    add.setAttribute('disabled', 'true');
    mutate('add.js', { items: [{ id: Number(id), quantity: 1 }] }).catch(function () {}).finally(function () { add.removeAttribute('disabled'); });
  });

  /* slider arrows */
  function recScroll(dir) {
    var list = document.querySelector('[data-sb-recs-list]');
    if (!list) return;
    var card = list.querySelector('.sb-rec');
    var w = card ? card.getBoundingClientRect().width + 10 : list.clientWidth * 0.85;
    list.scrollBy({ left: dir * w, behavior: 'smooth' });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-sb-recs-prev]')) { e.preventDefault(); recScroll(-1); }
    else if (e.target.closest && e.target.closest('[data-sb-recs-next]')) { e.preventDefault(); recScroll(1); }
  });

  /* remove line (live key lookup) */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest ? e.target.closest('[data-sb-remove]') : null;
    if (!rm || lock) return;
    e.preventDefault();
    var vid = Number(rm.getAttribute('data-sb-remove'));
    if (!vid) return;
    getJSON(root() + 'cart.js').then(function (cart) {
      var line = (cart.items || []).filter(function (i) { return i.variant_id === vid; })[0];
      if (line) mutate('change.js', { id: line.key, quantity: 0 }).catch(function () {});
    });
  });

  /* qty stepper (live key lookup) */
  var qtyBusy = false;
  document.addEventListener('click', function (e) {
    var q = e.target.closest ? e.target.closest('[data-sb-qty]') : null;
    if (!q || qtyBusy || lock) return;
    e.preventDefault();
    var vid = Number(q.getAttribute('data-vid'));
    var dir = q.getAttribute('data-sb-qty') === 'inc' ? 1 : -1;
    if (!vid) return;
    qtyBusy = true;
    getJSON(root() + 'cart.js').then(function (cart) {
      var line = (cart.items || []).filter(function (i) { return i.variant_id === vid; })[0];
      if (!line) { qtyBusy = false; return; }
      var nq = line.quantity + dir; if (nq < 0) nq = 0;
      return mutate('change.js', { id: line.key, quantity: nq });
    }).catch(function () {}).finally(function () { qtyBusy = false; });
  });

  function loadRecs(cartArg) {
    var wrap = document.querySelector('[data-sb-recs]');
    var list = document.querySelector('[data-sb-recs-list]');
    if (!wrap || !list) return;
    var go = cartArg ? Promise.resolve(cartArg) : getJSON(root() + 'cart.js');
    go.then(function (cart) {
      var items = (cart.items || []).filter(function (i) { return i.variant_id !== PROTECT; });
      if (!items.length) { wrap.hidden = true; return; }
      var key = items.map(function (i) { return i.product_id; }).sort().join(',');
      if (key === recsKey && list.children.length) { wrap.hidden = false; return; }
      if (key === recsKey && recsHtml) { list.innerHTML = recsHtml; wrap.hidden = false; enableSwipe(list); return; }
      var pid = items[0].product_id;
      var inCart = {}; items.forEach(function (i) { inCart[i.product_id] = 1; });
      function fallback() {
        if (recsHtml && key === recsKey) { list.innerHTML = recsHtml; wrap.hidden = false; enableSwipe(list); return; }
        if (list.children.length) { wrap.hidden = false; return; }
        wrap.hidden = true;
      }
      getJSON(root() + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=related').then(function (data) {
        var prods = (data.products || []).filter(function (p) { return !inCart[p.id] && p.available; }).slice(0, 6);
        if (!prods.length) { fallback(); return; }
        var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
        var addLabel = ((window.Shopify && Shopify.locale) === 'es') ? '+ Añadir' : '+ Add';
        function money(c) { return (c / 100).toLocaleString(undefined, { style: 'currency', currency: cur }); }
        var html = '';
        prods.forEach(function (p) {
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var priceHtml = (p.compare_at_price && p.compare_at_price > p.price)
            ? '<span class="sb-rec__was">' + money(p.compare_at_price) + '</span> <span class="sb-rec__now">' + money(p.price) + '</span>'
            : '<span class="sb-rec__now">' + money(p.price) + '</span>';
          var variants = (p.variants || []).filter(function (v) { return v.available; });
          var firstId = variants.length ? variants[0].id : (p.variants && p.variants[0] && p.variants[0].id) || '';
          var sel = '';
          if (variants.length > 1) {
            sel = '<select class="sb-rec__variant" data-sb-rec-variant>';
            variants.forEach(function (v) { sel += '<option value="' + v.id + '">' + (v.title || '') + '</option>'; });
            sel += '</select>';
          }
          html += '<div class="sb-rec">' +
            '<a class="sb-rec__imgwrap" href="' + p.url + '"><img class="sb-rec__img" src="' + img + '" alt="" loading="lazy"></a>' +
            '<div class="sb-rec__body">' +
              '<a class="sb-rec__title" href="' + p.url + '">' + p.title + '</a>' +
              '<div class="sb-rec__price">' + priceHtml + '</div>' +
              '<div class="sb-rec__actions">' + sel +
                '<button type="button" class="sb-rec__add" data-sb-rec-add="' + firstId + '">' + addLabel + '</button>' +
              '</div>' +
            '</div>' +
          '</div>';
        });
        list.innerHTML = html; recsHtml = html; recsKey = key; wrap.hidden = false; enableSwipe(list);
      }).catch(function () { fallback(); });
    }).catch(function () {});
  }

  function enableSwipe(list) {
    if (list.__ssSwipe) return;
    list.__ssSwipe = true;
    var down = false, startX = 0, startScroll = 0, moved = false, captured = false, pid = null;
    list.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') { down = true; moved = false; captured = false; pid = e.pointerId; startX = e.clientX; startScroll = list.scrollLeft; }
    });
    list.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 3) { moved = true; try { list.setPointerCapture(pid); captured = true; } catch (x) {} }
      if (moved) list.scrollLeft = startScroll - dx;
    });
    function end() { down = false; if (captured) { try { list.releasePointerCapture(pid); } catch (x) {} captured = false; } }
    list.addEventListener('pointerup', end);
    list.addEventListener('pointercancel', end);
    list.addEventListener('pointerleave', end);
    list.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }

  /* re-sync after the drawer opens, after add-to-cart, on load */
  function syncFromServer() { getJSON(root() + 'cart.js').then(function (c) { ensureProtect(c); loadRecs(c); }).catch(function () {}); }

  /* A real product was just added to the cart (by product-form, quick-add, or a rec).
     Protection must be ON: clear any opt-out and ensure it is in the cart. This makes
     "add a product -> protection on" reliable regardless of drawer-open timing. */
  var selfProtectAdd = false;
  function addProtectionMutate() {
    selfProtectAdd = true;
    return mutate('add.js', { items: [{ id: PROTECT, quantity: 1 }] }, 'footer').finally(function () { setTimeout(function () { selfProtectAdd = false; }, 300); });
  }
  function onExternalAdd() {
    try { localStorage.removeItem(OPTOUT); } catch (e) {}
    getJSON(root() + 'cart.js').then(function (cart) {
      if (eligibleCount(cart) >= 1 && !hasProtect(cart) && !lock) {
        lock = true;
        addProtectionMutate().catch(function () {}).finally(function () { lock = false; });
      } else {
        loadRecs(cart);
      }
    }).catch(function () {});
  }

  /* Patch fetch once to detect cart-add calls (works for any add path on the store). */
  function patchFetch() {
    if (window.__ssFetchPatched || !window.fetch) return;
    window.__ssFetchPatched = true;
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function () { if (!selfProtectAdd) setTimeout(onExternalAdd, 60); }).catch(function () {});
      }
      return p;
    };
  }

  function init() {
    patchFetch();
    syncFromServer();
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.wt-cart__trigger')) setTimeout(syncFromServer, 300);
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.source === 'ss-cart') return;
        setTimeout(syncFromServer, 60);
      });
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(function () { if (drawer.hasAttribute('open')) syncFromServer(); })
        .observe(drawer, { attributes: true, attributeFilter: ['open'] });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
